<div class="apply-changes-dialog">
  <h3 mat-dialog-title>Apply Changes to Campaigns</h3>
  <p class="dialog-description">
    Select which campaigns to apply the changes to:
  </p>
  <mat-dialog-content>
    <div class="select-all-section">
      <mat-checkbox
        [(ngModel)]="selectAll"
        (change)="toggleSelectAll()"
        [indeterminate]="selectedCount > 0 && selectedCount < data.campaigns.length"
        disableRipple
        class="flat-checkbox"
      >
        Select All
      </mat-checkbox>
    </div>

    <div class="campaigns-list">
      @for (campaign of data.campaigns; track campaign.campaignId) {
      <div class="campaign-item no-hover" tabindex="-1">
        <mat-checkbox
          [checked]="isCampaignSelected(campaign.campaignId)"
          (change)="toggleCampaign(campaign.campaignId)"
          disableRipple
          class="flat-checkbox"
        >
          <span class="campaign-title">{{ campaign.campaignTitle }}</span>
        </mat-checkbox>
      </div>
      }
    </div>

    @if (!hasSelection) {
    <div class="warning-message">
      <mat-icon>warning</mat-icon>
      <span>Please select at least one campaign to continue</span>
    </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="onApply()"
      [disabled]="!hasSelection"
    >
      Apply Changes
    </button>
  </mat-dialog-actions>
</div>
